import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { maxYear, minYear } from '@app/global-constants';
import { distinctUntilChanged, Subscription } from 'rxjs';

// TODO refactor na ControlValueAccessor
@Component({
  selector: 'app-select-year',
  templateUrl: './select-year.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectYearComponent implements OnInit, OnDestroy {
  @Output() readonly valueChanges = new EventEmitter<number>();
  @Input() showError?: string;
  @Input() minYear = minYear;
  @Input() maxYear = maxYear;
  @Input() selectedYear = new FormControl<number>(null);
  readonly years: number[] = [];
  yearSub$: Subscription;

  @Input() set currentYear(value: number) {
    this.selectedYear.setValue(Number(value));
  }

  ngOnInit(): void {
    this.populateYearsArray();
    this.setFormControlSub();
  }

  ngOnDestroy(): void {
    if (this.yearSub$) {
      this.yearSub$.unsubscribe();
    }
  }

  private populateYearsArray(): void {
    for (let year = this.maxYear; year >= this.minYear; year--) {
      this.years.push(year);
    }
  }

  private setFormControlSub(): void {
    this.yearSub$ = this.selectedYear.valueChanges.pipe(distinctUntilChanged()).subscribe((val) => {
      this.valueChanges.emit(val);
    });
  }
}
